import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslationPlatform } from '@models/system';
import { environment } from 'src/environments/environment';

/** Translation bundles keyed by platform name, each a flat key/value map for a single language. */
export type TranslationBundles = Partial<Record<keyof typeof TranslationPlatform, Record<string, string>>>;

/**
 * Fetches translation bundles from the backend. Kept intentionally dependency-free (only
 * `HttpClient`) so it can be safely used by `TranslationApiLoader` — the ngx-translate loader
 * that is constructed while building `TranslateService` itself. `TranslationService` depends on
 * `TranslateService` (indirectly, via `SignalRService`), so the loader cannot depend on
 * `TranslationService` without creating a circular dependency.
 */
@Injectable({ providedIn: 'root' })
export class TranslationBundlesService {
  private readonly httpClient = inject(HttpClient);

  /** Returns translation bundles for the given language and platform(s), grouped by platform name. */
  getBundles(languageCode: string, platforms: TranslationPlatform[]): Observable<TranslationBundles> {
    const params = platforms.map(p => `platforms=${p}`).join('&');
    return this.httpClient.get<TranslationBundles>(
      `${environment.baseApiUrl}_api/translations/${languageCode}?${params}`,
    );
  }
}
